import { type UploadedFile } from './factory'

export const MAX_UPLOAD = 32 * 1024 * 1024

export async function uploadFile(boardId: string, file: File): Promise<UploadedFile> {
  if (file.size > MAX_UPLOAD) throw new Error('too_large')
  const res = await fetch(`/api/boards/${boardId}/files`, {
    method: 'POST',
    headers: {
      'content-type': file.type || 'application/octet-stream',
      'x-filename': encodeURIComponent(file.name || 'file'),
    },
    body: file,
  })
  if (!res.ok)
    throw new Error(
      ((await res.json().catch(() => ({}))) as { error?: string }).error ?? 'upload_failed',
    )
  return (await res.json()) as UploadedFile
}

export async function imageSize(file: File): Promise<{ w: number; h: number } | undefined> {
  if (!file.type.startsWith('image/')) return undefined
  try {
    const bmp = await createImageBitmap(file)
    const size = { w: bmp.width, h: bmp.height }
    bmp.close()
    return size
  } catch {
    return undefined
  }
}

export function fileUrl(boardId: string, fileKey: string) {
  return `/api/boards/${boardId}/files/${fileKey}`
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`
  return `${(n / 1024 / 1024).toFixed(1)} MB`
}

export function isProbablyUrl(text: string): boolean {
  const t = text.trim()
  if (/\s/.test(t)) return false
  try {
    const u = new URL(t)
    return u.protocol === 'http:' || u.protocol === 'https:'
  } catch {
    return false
  }
}
